<template>
  <div :key="keyUnico">
    <b-row>
      <b-col sm="3" class="d-none d-sm-block">
        <FiltroHoteles :data="filtros" v-if="readyFiltro" v-once :key="`fil-${keyUnico}`" />
      </b-col>
      <b-col sm="9">
        <component v-bind:is="loadingComponent"></component>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex"
import FiltroHoteles from "@/components/hoteles/FiltroHoteles.vue"
import LoadingPanelHotel from "@/components/hoteles/LoadingPanelHotel.vue"
import ContenedorRsHotel from "@/components/hoteles/ContenedorRsHotel.vue"
import moment from "moment"
import { mapMutations } from "vuex"
export default {
  name: "resultadoHotelesCupo",
  props: ["data"],
  components: {
    FiltroHoteles,
    LoadingPanelHotel,
    ContenedorRsHotel
  },
  mounted() {
    this.setValidarSegunBusqueda(true) //  validará que lo que este en el carrito sea lo mismo que se colocó en la busqueda
    if (
      Object.entries(this.data.rs.disponibilidad.hoteles).length === 0 &&
      this.data.rs.disponibilidad.hoteles.constructor === Object
    ) {
      this.showToasted(
        "No hay hoteles disponibles para la fecha del cupo seleccionado, intente con otra fecha.",
        "error",
        7000
      )
      this._$goToInicio()
      return
    }
    this.manejoRsDispoOk(this.data)
  },
  activated() {
    this.setValidarSegunBusqueda(true) //  validará que lo que este en el carrito sea lo mismo que se colocó en la busqueda
    if (this.mountedExecuted && this.data != undefined) {
      // Para refrescar una busqueda nueva
      this.manejoRsDispoOk(this.data)
    }
    if (this.mountedExecuted) {
      let boton = this.prepararContinua()
      this.$store.dispatch("carrito/saveBoton", boton)
    }
    this.mountedExecuted = true
  },
  created() {},
  data: function() {
    return {
      uid: null,
      gastos: null,
      readyFiltro: false,
      openModalCarrito: false,
      mountedExecuted: false,
      keyUnico: null,
      filtros: null
    }
  },
  methods: {
    manejoRsDisponibilidad(rs, status) {
      switch (status) {
        case 200:
          this.estaOkDispo(rs)
          break

        default:
          break
      }
    },
    manejoRsDispoOk(data) {
      try {
        var resultado = Array.isArray(data.rs.disponibilidad.hoteles.hotel)
          ? data.rs.disponibilidad.hoteles.hotel
          : [data.rs.disponibilidad.hoteles.hotel]
        this.$store.dispatch("filtroHoteles/guardarTodosHoteles", {
          todos: resultado,
          rq: data.rs.rq
        })
        this.$store.dispatch("filtroHoteles/setFiltros", data.rs.filtros)
        this.gastos = data.rs.gasto
        this.uid = data.rs.uid
        this.filtros = data.rs.filtros
        this.$store.dispatch("carrito/tomaHabitacionesCupo", data.busqueda)
        this.setKeyUnico()
        this.readyFiltro = true
      } catch (e) {
        console.log(e)
        console.log("redirect")
        //this.$router.push({name: 'inicio'});
      }
    },
    estaOkDispo(rs) {
      if (rs.hoteles.hotel === undefined) {
        alert("Redireccionar a Inicio, sin dispo")
        return
      }
      this.manejoRsDispoOk(rs)
    },
    setModal() {
      this.openModalCarrito = !this.openModalCarrito
    },
    setKeyUnico() {
      this.keyUnico = moment().unix()
    },
    prepararContinua() {
      if (!this.segunBusqueda) {
        return this.validacionSinRsvCupos()
      }
      const continua = this.validHab.every(valid => valid.tomado)
      var btnmsg = "¡Faltan por seleccionar!"
      var variant = "orange"
      let disabled = true
      let goto = null
      if (continua) {
        btnmsg = "Continuar"
        variant = "light-blue darken-4"
        goto = "adicionalesHoteleria"
        disabled = false
      }
      return this._$toBotonCarrito(btnmsg, goto, variant, disabled)
    },
    ...mapMutations("carrito", {
      setValidarSegunBusqueda: "setValidarSegunBusqueda"
    })
  },
  computed: {
    ...mapGetters("carrito", {
      validHab: "getValidHab",
      segunBusqueda: "getValidarSegunBusqueda"
    }),
    ...mapGetters("filtroHoteles", {
      isFiltrando: "isFiltrando"
    }),
    continua: function() {
      if (!this.segunBusqueda) {
        return this._$toBotonCarrito("Ingresar datos de los pasajeros", "adicionalesHoteleria", "primary", true)
      }
      const continua = this.validHab.every(valid => valid.tomado)
      var btnmsg = "¡Faltan por seleccionar!"
      var variant = "orange"
      let disabled = true
      let goto = null
      if (continua) {
        btnmsg = "Continuar"
        variant = "light-blue darken-4"
        goto = "adicionalesHoteleria"
        disabled = false
      }
      return this._$toBotonCarrito(btnmsg, goto, variant, disabled)
    },
    loadingComponent: function() {
      let componente = "loadingPanelHotel"
      if (!this.isFiltrando) {
        componente = "contenedorRsHotel"
      }
      return componente
    }
  },
  watch: {
    continua(newCount, oldCount) {
      if (!this._inactive) {
        this.$store.dispatch("carrito/saveBoton", newCount)
      }
    }
  }
}
</script>
<style scoped="">
.badge-as {
  border-radius: 0;
}
</style>
